<app-component-header></app-component-header>

<div class="component-block">
  <section class="body-qr">
    <div class="container">
      <div class="content mb-3">
        <div class="px-3 pb-3">
          <div class="spinner-border text-primary" role="status" [hidden]="isSendingData">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="spinner-align" [hidden]="isSendingData"></div>
          <div class="text-sacom small">
            <div class="form-name">{{title}}</div>
            <form nz-form [formGroup]="formGroup" (keydown.enter)="$event.preventDefault()">
              <div *ngIf="steps.length > 1">
                <nz-skeleton [nzLoading]="!steps" nzActive="true"></nz-skeleton>
                <nz-steps [nzCurrent]="currentStep" (nzIndexChange)="stepIndexChange($event)"
                  nzLabelPlacement="vertical" nzType="navigation" nzSize="small">
                  <nz-step nzTitle='{{step.stepName}}' *ngFor="let step of steps"
                    [nzDisabled]="step.step > stepProcessing">
                  </nz-step>
                </nz-steps>
              </div>
              <nz-skeleton [nzLoading]="!formFieldInfo" nzActive="true"></nz-skeleton>
              <div nz-row class="row" #EformData>
                <span *ngFor="let c of formFieldInfo" [hidden]="c.isHidden || isHidden(c)" [ngClass]="getCol(c)">
                  <div *ngIf="c.fieldTypeCode == 'TITLE' && isShowComponent(c)">
                    <app-component-title id="{{c.fieldCode}}" [formFieldInfo]="c" class="main-form directive-component">
                    </app-component-title>
                  </div>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT' && isShowComponent(c)">
                    <app-component-text id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-text>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'TABLE_COMPLEX' && isShowComponent(c)">
                    <app-component-table-complex id="{{c.fieldCode}}" (tableEmit)="tableOutput($event)"
                      [formGroup]="formGroup" [formFieldInfo]="c" class="main-form directive-component">
                    </app-component-table-complex>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER' && isShowComponent(c)">
                    <app-component-number id="{{c.fieldCode}}" [formFieldInfo]="c" class="main-form directive-component"
                      (numberEmit)="numberAddEvent($event)" [formGroup]="formGroup"> </app-component-number>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'TEXTAREA' && isShowComponent(c)">
                    <app-component-textarea id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-textarea>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'DATE' && isShowComponent(c)">
                    <app-component-date id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-date>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'DATETIME' && isShowComponent(c)">
                    <app-component-datetime id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-datetime>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'SELECTLIST_SINGLE' && isShowComponent(c)">
                    <app-component-single-select id="{{c.fieldCode}}" [formFieldInfo]="c"
                      class="main-form directive-component" (selectEmit)="selectOutput($event)"
                      [inputData]="selectChildData" [formGroup]="formGroup"> </app-component-single-select>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'SPACE' && isShowComponent(c)"></nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'MULTIPLE_CHOICE' && isShowComponent(c)">
                    <app-component-multiple-choice id="{{c.fieldCode}}" [formFieldInfo]="c"
                      class="multi-choice-control parent-section directive-component"
                      [inputCustomfieldOptionList]="getMultipleChoiceCustomfieldList(c)" [itemList]="getSubItemsList(c)"
                      [listFormFieldInfo]="formFieldInfo" [formGroup]="formGroup">
                    </app-component-multiple-choice>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'RADIO_BUTTON' && isShowComponent(c)">
                    <app-component-radiobutton id="{{c.fieldCode}}" [formFieldInfo]="c"
                      class="radio-button-control parent-section directive-component"
                      [listFormFieldInfo]="formFieldInfo" [itemList]="getSubItemsList(c)"
                      [numberFormFieldInfo]="numberFormFieldInfo" [formGroup]="formGroup">
                    </app-component-radiobutton>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'LABEL' && isShowComponent(c)">
                    <app-component-label id="{{c.fieldCode}}" [formFieldInfo]="c" class="main-form directive-component">
                    </app-component-label>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'CHECK_BOX' && isShowComponent(c)">
                    <app-component-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-checkbox>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'NUMBER_CURRENCY' && isShowComponent(c)">
                    <app-component-number-currency id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-number-currency>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'TEXT_CHECK_BOX' && isShowComponent(c)">
                    <app-component-text-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-text-checkbox>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'DATE_CHECK_BOX' && isShowComponent(c)">
                    <app-component-date-checkbox id="{{c.fieldCode}}" [formFieldInfo]="c" [formGroup]="formGroup"
                      class="main-form directive-component"> </app-component-date-checkbox>
                  </nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == ' ' && isShowComponent(c)"></nz-form-item>
                  <nz-form-item *ngIf="c.fieldTypeCode == 'UPLOAD_FILE' && isShowComponent(c)"> </nz-form-item>
                </span>
              </div>
              <div class="row footer-action-step">
                <div class="col-md-6 col-xs-12">
                  <nz-skeleton-element *ngIf="!formFieldInfo" nzType="button" nzActive="true"></nz-skeleton-element>
                  <button [hidden]="!formFieldInfo" class="btn-back float-left" (click)="pre()" *ngIf="currentStep > 0"
                    ng-reflect-nz-type="default">
                    <span class="ng-star-inserted">Về trước</span>
                  </button>
                </div>
                <div class="col-md-6 col-xs-12">
                  <nz-skeleton-element *ngIf="currentStep + 1 < stepNum && !formFieldInfo" nzType="button"
                    nzActive="true"></nz-skeleton-element>
                  <button [hidden]="!formFieldInfo" class="btn-skip float-right" (click)="next()"
                    *ngIf="currentStep + 1 < stepNum" ng-reflect-nz-type="default">
                    <span class="ng-star-inserted">Kế tiếp</span>
                  </button>
                  <nz-skeleton-element *ngIf="currentStep + 1 == stepNum && !formFieldInfo" nzType="button"
                    nzActive="true"></nz-skeleton-element>
                  <button [hidden]="!formFieldInfo" class="btn-skip float-right" (click)="submitForm()"
                    *ngIf="currentStep + 1 == stepNum" ng-reflect-nz-type="default">
                    <span class="ng-star-inserted">Hoàn tất</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <nz-back-top></nz-back-top>
  </section>
</div>

<app-component-footer></app-component-footer>